import React, { useState, useEffect, Fragment } from "react";
import {
  Card,
  Menu,
  Dropdown,
  Layout,
  Row,
  Col,
  Button,
  Input,
  Table,
  Modal,
  Badge,
  message,
  Space,
  Upload,
  Avatar,
} from "antd";
import { Link, Redirect } from "react-router-dom";
import Axios from "axios";
import moment from "moment";
import { url } from "../../config/global";
import {
  UserOutlined,
  MoreOutlined,
  EditOutlined,
  QrcodeOutlined,
  DeleteOutlined,
  PlusOutlined,
  ImportOutlined,
  ExportOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import "./MasterUserInternal.less";
import fileDownload from "js-file-download";

const { Search } = Input;
const { Content } = Layout;

function MasterUserInternal() {
  const [loadingExport, setloadingExport] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPagesize] = useState(10);
  const [buttonAccess, setButtonAccess] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [data, setData] = useState([]);
  const [sort, setSort] = useState({
    sort: "created_at",
    order: "descend",
  });

  const handleSearch = (value) => {
    setKeyword(value);
  };

  useEffect(() => {
    getData(keyword, page, sort);
    const pathname = window.location.pathname.split("/");
    const currentUrl = pathname[1];
    const permissions =
      sessionStorage.getItem("permissions") &&
      JSON.parse(sessionStorage.getItem("permissions"));

    if (permissions) {
      const findPermission = permissions.find(
        (permission) => permission.url === currentUrl
      );

      const findChildPermission = permissions
        .map((child) => {
          return child.children.find(
            (grandChild) => grandChild.url === currentUrl
          );
        })
        .filter((grandChild) => grandChild)[0];

      if (findChildPermission && findChildPermission.children) {
        if (findChildPermission.children) {
          const findButtonAccessChildren = findChildPermission.children
            .filter((x) => x !== null)
            .filter((x) => x.permission_type === "button");
          if (findButtonAccessChildren) {
            setButtonAccess(findButtonAccessChildren.filter((x) => x !== null));
          }
        }
      }

      if (findPermission && findPermission.children) {
        const findButtonAccess = findPermission.children.filter(
          (x) => x.permission_type === "button"
        );
        if (findButtonAccess) {
          setButtonAccess(findButtonAccess);
        }
      }
    }
  }, [keyword, page, sort]);

  const getData = () => {
    setLoading(true);
    Axios.get(`${url}/master-user-internal`, {
      params: {
        keyword,
        columns: [
          "user.username",
          "user.email",
          "full_name",
          "npk",
          "department",
          "vendor_code",
          "vendor_name",
          "role_id",
          "role_name",
          "phone_number",
          "photo",
          "password",
          "retype_password",
          "storage",
        ],
        perpage: pageSize,
        page,
        sort: sort.sort,
        order: sort.order,
      },
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        setUsers(res.data);
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
          if (err.response.status === 401) {
            sessionStorage.removeItem("token");
          }
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDelete = (id) => {
    Modal.confirm({
      title: "Are you sure?",
      content: (
        <div>
          <p>Deleted data cannot be restored</p>
        </div>
      ),
      okText: "Delete",
      showCancel: true,
      onCancel: () => {
        return;
      },
      cancelText: "Cancel",
      confirmLoading: loading,
      onOk: async () => {
        confirmDelete(id);
      },
    });
  };

  const confirmDelete = (id) => {
    setLoading(true);
    Axios.delete(`${url}/master-user-internal/${id}`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        message.success(res.data.message);
        getData();
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
          if (err.response.status === 401) {
            sessionStorage.removeItem("token");
          }
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleTableChange = (pagination, filters, sorter) => {
    console.log("aa", sorter.order);
    setPage(pagination.current);
    setPagesize(pagination.pageSize);

    setSort({
      sort: sorter.field,
      order: sorter.order,
    });
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setData({
      ...data,
      file: null,
    });
    setIsModalVisible(false);
  };
  const onGenerate = (id) => {
    setLoading(true);

    let fd = new FormData();
    fd.set("id", id);

    Axios.post(`${url}/master-user-internal/qr-generate`, fd, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        ShiftCode: sessionStorage.getItem("shift_code"),
      },
    })
      .then((res) => {
        // message.success(res.data.message);
        Modal.success({
          title: "Success!",
          content: res.data.message,
        });
        // window.open(res.data.pdf, "_blank");
        window.open(res.data.filename);
        setLoading(false);
      })
      .catch((err) => {
        if (err.response) {
          Modal.error({
            title: "Failed!",
            content: err.response.data.message,
          });
          // message.error(err.response.data.message);
          if (err.response.status === 422) {
            Modal.error({
              title: "Failed!",
              content: err.response.data.errors,
            });
          }
          if (err.response.status === 401) {
            sessionStorage.removeItem("token");
          }
        }
        setLoading(false);
      });
  };
  const handleBeforeUpload = (files) => {
    setData({
      ...data,
      file: files,
    });

    return false;
  };

  const handleRemove = () => {
    setData({
      ...data,
      file: null,
    });
  };

  const downloadTemplate = () => {
    Axios.get(`${url}/master-user-internal/template`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
      responseType: "blob",
    }).then((res) => {
      fileDownload(res.data, "Template Master User Internal" + ".xlsx");
    });
  };

  const exportUserinternal = () => {
    setloadingExport(true);

    Axios.get(`${url}/master-user-internal/export`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
      responseType: "blob",
    })
      .then((res) => {
        fileDownload(res.data, "Export Master User Internal" + ".xlsx");
      })
      .finally(() => {
        setloadingExport(false);
      });
  };

  const onSaveData = () => {
    setLoading(true);

    let fd = new FormData();

    fd.append("file", data.file);

    Axios.post(`${url}/master-user-internal/import`, fd, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        message.success(res.data.message);
        getData();
        closeModal();
      })
      .catch((err) => {
        if (err.response) {
          const errorsKey = Object.keys(err.response.data.errors);
          const errors = err.response.data.errors;

          message.open({
            message: `Error!: ${err.response.data.message}`,
            description: (
              <div>
                Error Details:
                {errorsKey.map((error) => {
                  return <div>{errors[error][0]}</div>;
                })}
              </div>
            ),
          });

          if (err.response.status === 401) {
            sessionStorage.removeItem("token");
          }
        } else {
          message.error("Backend not yet Started");
        }
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const columns = [
    {
      title: "Foto",
      sorter: true,
      align: "center",
      render: (data) =>
        data.user != null ? (
          <Avatar src={data.user.photo_url} />
        ) : (
          <Avatar icon={<UserOutlined />} />
        ),
    },
    {
      title: "Username",
      sorter: true,
      dataIndex: "user.username",
      render: (data, row) => <div>{row.user?.username ?? ""}</div>,
    },
    {
      title: "Nama Lengkap",
      dataIndex: "full_name",
      sorter: true,
    },
    {
      title: "NPK",
      dataIndex: "npk",

      sorter: true,
    },
    {
      title: "Departemen",
      dataIndex: "department",
      sorter: true,
    },
    {
      title: "Email",
      sorter: true,
      dataIndex: "user.email",
      width: 300,
      render: (data, row) => <div>{row.user?.email ?? ""}</div>,
    },
    {
      title: "Area",
      dataIndex: "area",
      sorter: true,
    },
    {
      title: "Status QR Generate",
      sorter: true,
      render: (data) => {
        if (data.user?.last_qr_login_generate_at != null) {
          return (
            <div>
              <Badge
                count={"GENERATED"}
                style={{
                  backgroundColor: "green",
                  color: "white",
                  fontWeight: 500,
                }}
              />
              <small>{data.user.last_qr_login_generate_at}</small>
            </div>
          );
        } else {
          return (
            <div>
              <Badge
                count={"NOT GENERATED"}
                style={{
                  backgroundColor: "#6c757d",
                  color: "white",
                  fontWeight: 500,
                }}
              />
            </div>
          );
        }
      },
    },

    {
      title: "",
      dataIndex: "_id",
      align: "right",
      sorter: true,
      fixed: "right",
      width: 100,
      render: (id) => {
        return (
          <Fragment>
            <Dropdown
              className="pointer"
              overlay={
                <Menu>
                  {buttonAccess &&
                    buttonAccess.find(
                      (x) => x.url === "master-user-internal/edit"
                    ) && (
                      <Menu.Item key="1">
                        <span onClick={() => onGenerate(id)}>
                          <QrcodeOutlined /> Generate QR
                        </span>
                      </Menu.Item>
                    )}
                  {buttonAccess &&
                    buttonAccess.find(
                      (x) => x.url === "master-user-internal/edit"
                    ) && (
                      <Menu.Item key="1">
                        <Link to={`/master-user-internal/edit/${id}`}>
                          <EditOutlined /> Ubah
                        </Link>
                      </Menu.Item>
                    )}
                  {buttonAccess &&
                    buttonAccess.find(
                      (x) => x.url === "master-user-internal/delete"
                    ) && (
                      <Menu.Item key="2">
                        <span onClick={() => handleDelete(id)}>
                          <DeleteOutlined />
                          Hapus
                        </span>
                      </Menu.Item>
                    )}
                </Menu>
              }
              trigger={["click"]}
            >
              <span className="pointer" onClick={(e) => e.preventDefault()}>
                <MoreOutlined />
              </span>
            </Dropdown>
          </Fragment>
        );
      },
    },
  ];

  if (!sessionStorage.getItem("token")) {
    return <Redirect to="/login" />;
  }

  return (
    <Fragment>
      <Modal
        title="Import Master User Internal"
        visible={isModalVisible}
        footer={null}
        onCancel={closeModal}
      >
        <Card className="body-data">
          <div name="control-hooks">
            <div name="file" label="File">
              <Fragment>
                <Upload
                  onRemove={handleRemove}
                  beforeUpload={handleBeforeUpload}
                  fileList={[]}
                >
                  <Button style={{ marginBottom: 10 }}>
                    Pilih File <ExportOutlined />
                  </Button>
                </Upload>
                {data.file && (
                  <React.Fragment
                    children={[
                      <Button onClick={handleRemove} type="danger" ghost>
                        <DeleteOutlined />
                      </Button>,
                    ]}
                  >
                    {data.file.name ? data.file.name : data.file}
                  </React.Fragment>
                )}
              </Fragment>
            </div>
            <div>
              <Button
                loading={loading}
                onClick={onSaveData}
                type="primary"
                htmlType="submit"
                className="mr-button"
                style={{
                  marginRight: 10,
                }}
              >
                Unggah
              </Button>
              <Button htmlType="reset" onClick={handleRemove}>
                Batal
              </Button>
            </div>
          </div>
        </Card>
      </Modal>

      <Row>
        <Col xs={24}>
          <Card
            type="inner"
            aa
            title="Master User Internal"
            extra={moment(new Date()).format("DD MMMM YYYY")}
          ></Card>
        </Col>
      </Row>

      <Content className="content">
        <Row>
          <Col xs={24}>
            <Card className="body-data">
              <Row type="flex" gutter={[10, 20]} justify="space-around">
                <Col xs={24} md={12} lg={18}>
                  <Space>
                    {buttonAccess &&
                      buttonAccess.find(
                        (x) => x.url === "master-user-internal/create"
                      ) && (
                        <Link to="/master-user-internal/create">
                          <Button type="primary">
                            <PlusOutlined />
                            Tambah
                          </Button>
                        </Link>
                      )}
                    {buttonAccess &&
                      buttonAccess.find(
                        (x) => x.url === "master-user-internal/import"
                      ) && (
                        <Button type="primary" onClick={showModal}>
                          <ImportOutlined />
                          Import
                        </Button>
                      )}
                    {buttonAccess &&
                      buttonAccess.find(
                        (x) => x.url === "master-user-internal/export"
                      ) && (
                        <Button
                          loading={loadingExport}
                          onClick={exportUserinternal}
                          type="primary"
                        >
                          <ExportOutlined />
                          Export
                        </Button>
                      )}
                    {buttonAccess &&
                      buttonAccess.find(
                        (x) => x.url === "master-user-internal/template"
                      ) && (
                        <Button type="primary" onClick={downloadTemplate}>
                          <DownloadOutlined />
                          Download Template
                        </Button>
                      )}
                  </Space>
                </Col>
                <Col xs={24} md={12} lg={6} className="align-right">
                  <Search
                    placeholder="Search ..."
                    onSearch={(value) => handleSearch(value)}
                  />
                </Col>

                <Col xs={24}>
                  <Table
                    scroll={{ x: 1400, y: 500 }}
                    columns={columns}
                    dataSource={users.data}
                    rowKey={(data) => data._id}
                    onChange={handleTableChange}
                    pagination={{
                      pageSize: pageSize,
                      current: page,
                      total: users.total,
                      showSizeChanger: true,
                    }}
                    loading={loading}
                  />
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Content>
    </Fragment>
  );
}

export default MasterUserInternal;
